import handleScroll from './handlescroll';

const focusHandler = (elem, focusSelector) => {
  if (focusSelector) {
    const focusElem = elem.querySelector(focusSelector);
    if (focusElem) {
      focusElem.focus();
    }
  }
};

const scrollToInvalid = ({
  container,
  focusSelector,
  scrollToSelector,
}) => {
  const dispatch = () => {
    const event = document.createEvent('HTMLEvents');
    event.initEvent('scrollToInvalid',
      false,
      true);
    container.dispatchEvent(event);
  };

  container.addEventListener('scrollToInvalid',
    () => {
      const node = container.querySelector(scrollToSelector);

      // If the element to scroll to does not exist -- return.
      if (!node) {
        return;
      }

      handleScroll(
        node,
        500,
        focusHandler(node,
          focusSelector)
      );

    },
    false);

  return dispatch;
};

export default scrollToInvalid;
